import { Injectable } from '@angular/core';
import {
  delaisReglementairesInitialState,
  DelaisReglementairesStateProps,
  delaisReglementairesStateStore,
} from './delais-reglementaires-state.store';
import { select } from '@ngneat/elf';
import { BaseStoreRepository } from '../base-store.repository';

@Injectable({
  providedIn: 'root',
})
export class DelaisReglementairesRepository extends BaseStoreRepository<DelaisReglementairesStateProps> {
  constructor() {
    super(delaisReglementairesStateStore.pipe(select(state => state)), delaisReglementairesStateStore, delaisReglementairesInitialState);
  }
}
